import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useClassName } from 'common/hooks';
import { qrCodeToDataURL } from 'common/lazy';
import qrLogo from 'common/assets/qr-logo.svg';

import QRCodeModal from './QRCodeModal';
import { AttractionLogo } from '../../AttractionLogo';
import { getCodesList } from '../helper';

import './order-header.less';
import { Button } from 'common/lazy';
import ResendOrderConfirmation from './ResendOrderConfirmation';

export const OrderHeader = ({
  venue,
  bundle,
  tickets,
  profiles = [],
  bookingReference,
  order,
  handleModifyOrder,
  showResendButton,
  expiredTickets,
}) => {
  const className = useClassName('OrderHeader');

  const [qrCodes, setQrCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    async function generateQRCodes() {
      const codes = getCodesList(
        tickets,
        bookingReference,
        venue,
        bundle,
        profiles
      );
      const qrCodes = await Promise.all(
        codes.map(async (code) => ({
          srcImage: await qrCodeToDataURL(code.id, { width: 240, margin: 0 }),
          id: code.id,
          venueName: code.venueName,
          ticketHolder: code.ticketHolder,
          picture: code.picture,
          ticketName: code.ticketName,
          isTicket: code.isTicket,
        }))
      );
      setQrCodes(qrCodes);
      setLoading(false);
    }
    generateQRCodes();
  }, []);

  const renderModal = () => {
    return (
      <QRCodeModal
        qrCodes={qrCodes}
        isOpen={open}
        onClose={() => setOpen(false)}
      />
    );
  };

  const showModifyButton = () => {
    return (
      Boolean(bundle) &&
      !order.isRedeemed &&
      !bundle.passportType &&
      !venue.stripeAccount
    );
  };

  return (
    <div className={className('container')}>
      <div>
        <p className={className('booking-reference')}>
          Booking # {bookingReference}
        </p>
        <div className={className('logo-container')}>
          <AttractionLogo venue={venue} bundle={bundle} />
          <div className={className('qr-container')}>
            <div onClick={() => setOpen(true)}>
              {!loading && (
                <div className={className('qr-code')}>
                  <img src={qrLogo} alt="qr-code" />
                  <span>See QR</span>
                </div>
              )}
            </div>
            {showResendButton &&
              !expiredTickets &&
              order.status !== 'cancelled' && (
                <ResendOrderConfirmation
                  bookingReference={order.bookingReference}
                />
              )}
            {order.status === 'cancelled' && (
              <p className={className('cancelled')}>Cancelled</p>
            )}
          </div>
        </div>
      </div>
      {showModifyButton() && (
        <div className={className('bundle-name-container')}>
          <div className={className('bundle-name')}>{bundle.title}</div>
          <Button
            className={className('modify-btn')}
            onClick={() => handleModifyOrder(order, tickets, venue, bundle)}>
            Modify
          </Button>
        </div>
      )}
      {renderModal()}
    </div>
  );
};

OrderHeader.propTypes = {
  tickets: PropTypes.arrayOf(PropTypes.object).isRequired,
  profiles: PropTypes.arrayOf(PropTypes.object),
  venue: PropTypes.object,
  bundle: PropTypes.object,
  bookingReference: PropTypes.string.isRequired,
  order: PropTypes.object.isRequired,
  handleModifyOrder: PropTypes.func.isRequired,
  showResendButton: PropTypes.bool,
  expiredTickets: PropTypes.bool,
};
